interface FeatureRow {
  category: string;
  features: {
    name: string;
    desc?: string;
    free: boolean | string;
    premium: boolean | string;
    premiumPlus: boolean | string;
  }[];
}

const tableData: FeatureRow[] = [
  {
    category: 'Temel Özellikler',
    features: [
      { name: 'Rastgele Video Sohbet', free: true, premium: true, premiumPlus: true },
      { name: 'Metin Sohbeti', free: true, premium: true, premiumPlus: true },
      { name: 'Mobil Uygulama Desteği', free: true, premium: true, premiumPlus: true },
      { name: 'Raporla & Engelle', free: true, premium: true, premiumPlus: true },
    ],
  },
  {
    category: 'Video Kalitesi',
    features: [
      { name: 'Standart Kalite', free: true, premium: true, premiumPlus: true },
      { name: 'HD Video (720p)', free: false, premium: true, premiumPlus: true },
      { name: 'Full HD Video (1080p)', free: false, premium: false, premiumPlus: true },
    ],
  },
  {
    category: 'Filtreleme',
    features: [
      { name: 'Cinsiyet Filtresi', free: false, premium: true, premiumPlus: true },
      { name: 'Ülke / Bölge Filtresi', free: false, premium: true, premiumPlus: true },
      { name: 'Dil Filtresi', free: false, premium: true, premiumPlus: true },
      { name: 'Çoklu Filtre Kombinasyonu', free: false, premium: false, premiumPlus: true },
      { name: 'İlgi Alanı Filtresi', free: false, premium: false, premiumPlus: true },
    ],
  },
  {
    category: 'Eşleşme',
    features: [
      { name: 'Standart Eşleşme Hızı', free: true, premium: true, premiumPlus: true },
      { name: 'Öncelikli Eşleşme', desc: 'Kuyrukta öne geç', free: false, premium: true, premiumPlus: true },
      { name: 'Yeniden Bağlan', desc: 'Kaybettiğin bağlantıya geri dön', free: false, premium: true, premiumPlus: true },
      { name: 'VIP Eşleşme Havuzu', desc: 'Sadece premium kullanıcılar', free: false, premium: false, premiumPlus: true },
    ],
  },
  {
    category: 'Deneyim',
    features: [
      { name: 'Reklamlar', free: 'Var', premium: 'Yok', premiumPlus: 'Yok' },
      { name: 'Aylık Bağlantı Limiti', free: 'Sınırlı', premium: 'Sınırsız', premiumPlus: 'Sınırsız' },
      { name: 'Özel Profil Rozeti', free: false, premium: false, premiumPlus: true },
      { name: 'Öncelikli Destek', free: false, premium: false, premiumPlus: true },
    ],
  },
];

const CellValue = ({ value, planId }: { value: boolean | string; planId: string }) => {
  if (typeof value === 'string') {
    const color =
      value === 'Yok' || value === 'Sınırsız'
        ? planId === 'premium'
          ? 'text-yellow-400'
          : planId === 'plus'
          ? 'text-cyan-400'
          : 'text-white/50'
        : 'text-white/40';
    return <span className={`text-sm font-medium ${color}`}>{value}</span>;
  }
  if (value) {
    return (
      <div
        className={`w-6 h-6 flex items-center justify-center rounded-full mx-auto ${
          planId === 'premium'
            ? 'bg-yellow-500/20 text-yellow-400'
            : planId === 'plus'
            ? 'bg-cyan-500/15 text-cyan-400'
            : 'bg-white/8 text-white/50'
        }`}
      >
        <i className="ri-check-line text-xs" />
      </div>
    );
  }
  return (
    <div className="w-6 h-6 flex items-center justify-center rounded-full mx-auto bg-white/3">
      <i className="ri-close-line text-white/15 text-xs" />
    </div>
  );
};

const FeaturesTable = () => {
  return (
    <section className="py-16 md:py-20 bg-[#060810]">
      <div className="max-w-5xl mx-auto px-4 md:px-8">
        {/* Header */}
        <div className="text-center mb-12">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-white/5 border border-white/10 text-white/50 text-xs font-semibold mb-5">
            <i className="ri-table-line" />
            Detaylı Karşılaştırma
          </div>
          <h2 className="text-2xl md:text-4xl font-extrabold text-white mb-3">
            Hangi Plan Sana Uygun?
          </h2>
          <p className="text-white/40 text-sm md:text-base">
            Tüm özellikleri yan yana karşılaştır.
          </p>
        </div>

        {/* Table */}
        <div className="rounded-2xl border border-white/8 overflow-hidden">
          {/* Table header */}
          <div className="grid grid-cols-4 bg-white/3 border-b border-white/8">
            <div className="px-5 py-4 text-white/40 text-xs font-semibold uppercase tracking-widest">
              Özellik
            </div>
            <div className="px-4 py-4 text-center">
              <span className="text-white/60 text-sm font-bold">Ücretsiz</span>
            </div>
            <div className="px-4 py-4 text-center bg-yellow-500/5 border-l border-r border-yellow-500/15">
              <div className="flex flex-col items-center gap-1">
                <i className="ri-vip-crown-line text-yellow-400 text-base" />
                <span className="text-yellow-400 text-sm font-bold">Premium</span>
              </div>
            </div>
            <div className="px-4 py-4 text-center">
              <div className="flex flex-col items-center gap-1">
                <i className="ri-vip-diamond-line text-cyan-400 text-base" />
                <span className="text-cyan-400 text-sm font-bold">Premium+</span>
              </div>
            </div>
          </div>

          {/* Rows */}
          {tableData.map((category, catIdx) => (
            <div key={category.category}>
              {/* Category row */}
              <div className="grid grid-cols-4 bg-white/2 border-b border-white/5">
                <div className="col-span-4 px-5 py-3">
                  <span className="text-white/35 text-xs font-semibold uppercase tracking-widest">
                    {category.category}
                  </span>
                </div>
              </div>

              {/* Feature rows */}
              {category.features.map((feat, featIdx) => {
                const isLast =
                  catIdx === tableData.length - 1 &&
                  featIdx === category.features.length - 1;
                return (
                  <div
                    key={feat.name}
                    className={`grid grid-cols-4 hover:bg-white/2 transition-colors ${
                      !isLast ? 'border-b border-white/5' : ''
                    }`}
                  >
                    {/* Feature name */}
                    <div className="px-5 py-4">
                      <p className="text-white/70 text-sm">{feat.name}</p>
                      {feat.desc && (
                        <p className="text-white/30 text-xs mt-0.5">{feat.desc}</p>
                      )}
                    </div>
                    {/* Free */}
                    <div className="px-4 py-4 flex items-center justify-center">
                      <CellValue value={feat.free} planId="free" />
                    </div>
                    {/* Premium */}
                    <div className="px-4 py-4 flex items-center justify-center bg-yellow-500/3 border-l border-r border-yellow-500/10">
                      <CellValue value={feat.premium} planId="premium" />
                    </div>
                    {/* Premium+ */}
                    <div className="px-4 py-4 flex items-center justify-center">
                      <CellValue value={feat.premiumPlus} planId="plus" />
                    </div>
                  </div>
                );
              })}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FeaturesTable;
